import React from "react";

import Breadcrumbs from "../../../../../components/Breadcrumbs";
import ScheduleTimingTable from "./ScheduleTimingTable";
import ScheduleTimingModal from "../../../../../components/ScheduleTiming/ScheduleTimingModal";

import { useTranslation } from "react-i18next";

const ScheduleTiming = () => {

  const { t } = useTranslation();

  return (
    <>
      <div className="page-wrapper">
        <div className="content container-fluid">
          <Breadcrumbs
            maintitle={t('Schedule timing')}
            title="Dashboard"
            subtitle={t('Jobs')+' / '+t('Schedule timing')}
          />
          <ScheduleTimingTable />
          <ScheduleTimingModal />
        </div>
      </div>
    </>
  );
};

export default ScheduleTiming;
